import http from '@/assets/js/interceptor';
import util from '@/assets/js/util';
// 导出
export function exportDataApi (instApplyId, fileName) {
  return util.fileDownloadBydomanType({ fileName, ajax: http, url: `/instApply/export/${instApplyId}`, params: {}, domainType: 'bpmApi' });
}
// 转交
export function transferActionOpApi (data) {
  return http.post('/bpm/transferActionOp', data, { domainType: 'bpmApi' });
}
